import React, { useEffect, useState } from 'react'
import { Parallax } from 'react-parallax'

const FirstParallax = () => {

  const [width, setwidth] = useState(window.innerWidth)

 

  const openPdf = () =>{
    window.open('/Resume.pdf', '_blank').focus();
  }
  const backgroundImageUrl = process.env.PUBLIC_URL + '/paraImgs/desktop.jpg';
const backgroundImageUrlMobile = process.env.PUBLIC_URL + '/paraImgs/desktop-mobile.jpg';

  

  return (
    <>
    <Parallax
      className='paralax'
      bgImage={ width >= 600 ? backgroundImageUrl : backgroundImageUrlMobile}
      strength={400}
    >
      <div className='overlay'></div>
      <div className='logo animated-logo'> <a href="/">WELCOME</a> </div>
     
      <div id='home' className='mainhead'>
        <div className='left'>
          <div className='description animated-description'>
            <div className='heading'> <span className='bg-animation'>
             I'm Lokendra Kumar
            </span>
               </div> <br />
            Transforming ideas into stunning, user-centric websites that elevate your brand's online presence.
            
          </div>
        </div>
        <div className='links animated-links'>
          <a target={'_blank'} href='mailto:lokyadav945275@gmail.com'>
            <i class='fa fa-envelope-o' aria-hidden='true'></i>
          </a>
          <a target={'_blank'} href='https://github.com/HamkerLokie'>
            <i class='fa fa-github' aria-hidden='true'></i>
          </a>
          <a target={'_blank'} href='https://twitter.com/Lokendr36634148'>
            <i class='fa fa-linkedin' aria-hidden='true'></i>
          </a>
          <a target={'_blank'} href='https://www.instagram.com/_maverick.o1/?igshid=YmMyMTA2M2Y%3D'>
            <i class='fa fa-instagram' aria-hidden='true'></i>
          </a>
          <a target={'_blank'} href='https://twitter.com/Lokendr36634148'>
            <i class='fa fa-twitter' aria-hidden='true'></i>
          </a>
        </div>
      </div>

      <div  className='submissions animated-submissions'>
        <a href='#contacts' className='btn-sub'>Start Project</a>
        <button onClick={openPdf} className='btn-sub'>View Resume</button>
      </div>
    </Parallax>
   
    </>
  )
}

export default FirstParallax
